import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { CANALI, parseNum, toInput } from "@/lib/format";
import { Field, SimpleSelect, btnGhost, btnPrimary, inputCls } from "@/components/app/common";
import { CategoriaCombobox, catOpts } from "@/components/app/CategoriaCombobox";

export function BudgetDialog({ open, onOpenChange, item, categorie, onSaved }) {
  const [f, setF] = useState({ categoria: "", canale: "all", importo: "" });
  const [saving, setSaving] = useState(false);
  const set = (k) => (v) => setF((p) => ({ ...p, [k]: v }));

  useEffect(() => {
    if (open) setF(item ? { categoria: item.categoria, canale: item.canale || "all", importo: toInput(item.importo) } : { categoria: "", canale: "all", importo: "" });
  }, [open, item]);

  const save = async () => {
    const importo = parseNum(f.importo);
    if (!f.categoria) return toast.error("Seleziona una categoria");
    if (!(importo > 0)) return toast.error("Inserisci un importo maggiore di zero");
    setSaving(true);
    const body = { categoria: f.categoria, canale: f.canale === "all" ? null : f.canale, importo };
    try {
      if (item) await api.put(`/budget/${item.id}`, body);
      else await api.post("/budget", body);
      toast.success(item ? "Budget aggiornato" : "Budget creato");
      onOpenChange(false);
      onSaved();
    } catch (e) { toast.error(errMsg(e)); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-2xl sm:max-w-md" data-testid="budget-dialog" aria-describedby={undefined}>
        <DialogHeader><DialogTitle className="font-display font-medium text-2xl">{item ? "Modifica budget" : "Nuovo budget mensile"}</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <Field label="Categoria di costo"><CategoriaCombobox testId="budget-categoria-select" tipo="costo" value={f.categoria} onChange={set("categoria")} placeholder="Scegli o crea" options={catOpts(categorie)} /></Field>
          <Field label="Canale" hint="Scegli 'Tutti i canali' per un budget complessivo della categoria."><SimpleSelect testId="budget-canale-select" value={f.canale} onChange={set("canale")} options={[{ value: "all", label: "Tutti i canali" }, ...CANALI.map((c) => ({ value: c, label: c }))]} /></Field>
          <Field label="Budget mensile (imponibile €)"><Input data-testid="budget-importo-input" inputMode="decimal" value={f.importo} onChange={(e) => set("importo")(e.target.value)} className={inputCls} placeholder="0,00" /></Field>
        </div>
        <DialogFooter className="gap-2">
          <Button variant="outline" className={btnGhost} onClick={() => onOpenChange(false)}>Annulla</Button>
          <Button className={btnPrimary} onClick={save} disabled={saving} data-testid="budget-save-button">{saving ? <Loader2 className="h-4 w-4 animate-spin" /> : "Salva"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
